/* Replays $(document).ready callbacks queued by the head stub (see
   theme.liquid) once real jQuery has loaded from vendor.js. Loaded with
   defer immediately after vendor.js, so jQuery is guaranteed present and
   the DOM is parsed - jQuery(fn) fires each callback right away. */
(function () {
  var q = window.__jqReadyQueue;
  if (!q || !window.jQuery || !window.jQuery.fn) return;
  window.__jqReadyQueue = null;
  for (var i = 0; i < q.length; i++) {
    try { window.jQuery(q[i]); } catch (e) { console.error('queued ready callback failed:', e); }
  }
})();
